import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@acb_devel/design-system/Modal';
import { Heading, Text } from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system/Button';

import styles from './FeedbackDeleteModal.module.scss';

export function FeedbackDeleteModal({
  isOpen,
  closeModal,
  onDelete,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onDelete: () => void;
}) {
  return (
    <>
      <Modal isOpen={isOpen} onClose={closeModal} size="md">
        <ModalHeader closeModal={closeModal}></ModalHeader>
        <ModalBody>
          <div className={styles.feedbackDeleteModal__body}>
            <Heading as="p" variant="heading-2">
              ¿Estás seguro que quieres borrar el feedback?
            </Heading>
            <Text variant="body-1">Si lo borras desaparecerá de la lista.</Text>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className={styles.feedbackDeleteModal__buttons}>
            <Button color="primary" variant="outline" onClick={closeModal}>
              Cancelar
            </Button>
            <Button color="primary" variant="solid" onClick={onDelete}>
              Borrar
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}
